var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":_vm.xpathUrl,"width":"100%","height":"100%","frameborder":"0","sandbox":"allow-scripts allow-same-origin"}}),(_vm.loading)?_c('div',{staticClass:"loading-mask"},[_c('el-icon',{staticClass:"loading icon"},[_c('loading')],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }